module.exports = __webpack_public_path__ + "img/merbj.8704f956.jpg";